import { useEffect, useState } from "react";

export const GPS_CHECK_MIN_INTERVAL_MS = 10 * 60 * 1000;
export const GPS_CHECK_QC_INCIDENT_ATTEMPT_THRESHOLD = 5;

export function formatGpsCheckClock(ms: number): string {
  const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
}

export function useNowMs(intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(timer);
  }, [intervalMs]);
  return now;
}

export function gpsCheckRemainingMs(lastCheckStartedAt: string | null, nowMs: number): number {
  if (lastCheckStartedAt == null || lastCheckStartedAt.trim() === "") return 0;
  const started = Date.parse(lastCheckStartedAt);
  if (!Number.isFinite(started)) return 0;
  return Math.max(0, GPS_CHECK_MIN_INTERVAL_MS - (nowMs - started));
}

export function GpsCheckElapsed({ lastCheckStartedAt }: { lastCheckStartedAt: string | null }): JSX.Element {
  const nowMs = useNowMs();
  if (lastCheckStartedAt == null || lastCheckStartedAt.trim() === "") {
    return <p className="text-sm text-slate-600">No check has started yet.</p>;
  }
  const started = Date.parse(lastCheckStartedAt);
  if (!Number.isFinite(started)) {
    return <p className="text-sm text-slate-600">No check has started yet.</p>;
  }
  const elapsedMs = Math.max(0, nowMs - started);
  const remainingMs = gpsCheckRemainingMs(lastCheckStartedAt, nowMs);
  return (
    <p className="text-sm text-slate-700">
      Last check began {formatGpsCheckClock(elapsedMs)} ago.
      {remainingMs > 0
        ? ` Next check in ${formatGpsCheckClock(remainingMs)}.`
        : " A new check can start now."}
    </p>
  );
}
